const COUNTRY_ALIASES = new Map([['ITA', 'IT'], ['SMR', 'SM'], ['CHE', 'CH'], ['GBR', 'GB'], ['UK', 'GB']]);
const normalizeCountryCode = value => {
  if (typeof value !== 'string') return null;
  const code = value.trim().toUpperCase();
  return COUNTRY_ALIASES.get(code) || code || null;
};
module.exports = {
  normalizeCountryCode
};